export default {"src":"/_next/static/media/icon-salary-career.fb5be4fe.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};